import React, { useContext, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Card,
  TextStyle,
  Layout,
  SettingToggle,
  Page,
  Banner,
  SkeletonBodyText,
  SkeletonDisplayText,
  TextContainer,
  Button,
  Badge,
} from "@shopify/polaris";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import axios from "../../axios";
import { ShopContext } from "../../App";
import Br from "../../components/Br";
import RequestApproval from "../../components/RequestApproval";
import AppSubscribeBanner from "../../components/AppSubscribeBanner";
import AutomationLists from "./AutomationLists";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../../automation.css";
import { loadAutomations } from "../../utils";
import LearnHowSection from "../../components/LearnHow";

const Automation = () => {
  const config = useContext(ShopContext);
  const [loading, setLoading] = useState(false);
  const [abandonedArrow, setAbandonedArrow] = useState(false);
  const [confirmationArrow, setConfirmationArrow] = useState(false);
  const [deliveryArrow, setDeliveryArrow] = useState(false);
  const [dashboard, setDashboard] = useState({});
  const [activatingAutomation, setActivatingAutomation] = useState(false);
  const [
    activatingAutomationOrderPayment,
    setActivatingAutomationOrderPayment,
  ] = useState(false);
  const [
    activatingAutomationOrderDelivery,
    setActivatingAutomationOrderDelivery,
  ] = useState(false);
  const [automations, setAutomations] = useState([]);
  const [shop, setShop] = useState({});
  const router = useHistory();

  /**
   * process the response API
   * @param response
   * @private
   */
  const _processApiResponse = (response) => {
    if (response.success) {
      setShop(_.get(response, "shop", {}));
      setDashboard(_.get(response, "dashboard", {}));
      setAutomations(response.data.data);
    }
  };

  // Handle the tabs content based on the selected tab
  const handleTabIcons = (abandonedArrow, confirmationArrow, deliveryArrow) => {
    setAbandonedArrow(abandonedArrow);
    setConfirmationArrow(confirmationArrow);
    setDeliveryArrow(deliveryArrow);
  };

  /**
   * Delete the automation by ID
   * @param automationId
   */
  const deleteAutomation = (automationId) => {
    setLoading(true);
    axios
      .delete(`/automations/${automationId}?page=1`, {
        headers: {
          shopOrigin: config.shopOrigin,
          xShopHost: config.host,
        },
      })
      .then((response) => {
        setLoading(false);
        _processApiResponse(response);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const setToggleLoadingStatus = (type, status) => {
    if (type === "pre_order") {
      setActivatingAutomation(status);
    } else if (type === "post_order_payment") {
      setActivatingAutomationOrderPayment(status);
    } else {
      setActivatingAutomationOrderDelivery(status);
    }
  };

  /**
   * load automations from API's
   */
  const activateAutomations = (status, type = "pre_order") => {
    setToggleLoadingStatus(type, true);
    axios
      .post(
        `/automations/enable`,
        { status: status, type: type },
        {
          headers: {
            shopOrigin: config.shopOrigin,
            xShopHost: config.host,
          },
        }
      )
      .then((response) => {
        setToggleLoadingStatus(type, false);
        if (response.success) {
          setShop(response.shop);
        } else {
        }
      })
      .catch((error) => {
        setToggleLoadingStatus(type, false);
      });
  };

  /**
   * Load checkouts when page loads
   * or load when the particular state changed
   */
  useEffect(() => {
    loadAutomations(
      setShop,
      setLoading,
      setDashboard,
      setAutomations,
      config.shopOrigin,
      config.host
    );
    const index = config.tabIndex;
    if (index == "0") {
      handleTabIcons(true, false, false);
    } else if (index == "1") {
      handleTabIcons(false, true, false);
    } else {
      handleTabIcons(false, false, true);
    }
    // eslint-disable-next-line
  }, []);

  let hasSubscription = _.get(shop, "has_active_subscription", 0);
  let hasRequestedAlready = _.get(
    shop,
    "requested_to_activate_automation",
    null
  );
  let isEligible = _.get(shop, "is_eligible", 0);

  let orderPaymentNotification = automations.find(
    (notification) => notification.type === "post_order_payment"
  );
  let orderDeliveryNotification = automations.find(
    (notification) => notification.type === "post_order_delivery"
  );

  return (
    <Page fullWidth title="Automations">
      <Banner status="info">
        <p>
          <b>NOTE:</b> Automated WhatsApp message templates cannot be modified.
          These are pre-approved templates by WhatsApp. The messages are sent
          using a WhatsApp approved business API number. Your WhatsApp number &
          link are included in every message so that the customer can reach out
          to you if needed.
        </p>
        <p>
          To learn more about the cost of messages, Please{" "}
          <a
            href="https://docs.google.com/spreadsheets/d/1S_HvAcQXzekTl9JfH18iRljZfCeJnNJbvQaOoB8-Fic/edit#gid=0"
            target="_blank"
          >
            view the pricing
          </a>
          .
        </p>
      </Banner>
      <Banner status="info">
        <p>
          <b>NOTE:</b> Please make sure that you have enabled the Opt-In at your Checkout following this <a
            href="https://help.shopjar.co/whatsapp-automation/checkout-optin"
            target='_blank'>guide</a>. Only opt-in customers can be sent message as per WhatsApp Business requirements.
        </p>
      </Banner>
      <Br height={20} />
      {hasSubscription === 0 && !loading && (
        <div className="smallPricingTable">
          <AppSubscribeBanner
            setLoadingSubscription={() => {}}
            hasActiveSubscription={hasSubscription === 1}
            show={hasSubscription === 0}
            setHasActiveSubscription={() => {}}
          />
          <Br height={30} />
        </div>
      )}
      {/*{!loading && isEligible === 0 && (*/}
      {/*  <RequestApproval alreadyRequested={hasRequestedAlready} />*/}
      {/*)}*/}

      <div>
        <Layout>
          <Layout.Section>
            <Card>
              <Tabs defaultIndex={config.tabIndex}>
                <TabList>
                  <Tab
                    onClick={() => {
                      handleTabIcons(true, false, false);
                    }}
                  >
                    {loading ? (
                      <SkeletonDisplayText size="large" />
                    ) : (
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "80%" }}>
                          <TextStyle variation="strong">
                            Abandoned Cart Recovery&nbsp;
                          </TextStyle>
                        </div>
                        {!abandonedArrow ? (
                          <div id="abandoned_status">
                            {shop.is_automation_enabled ? (
                              <Badge status="success">Enabled</Badge>
                            ) : (
                              <Badge status="warning">Disabled</Badge>
                            )}
                          </div>
                        ) : (
                          <div
                            id="abandoned_arrow"
                            style={{ paddingLeft: "25%" }}
                          >
                            <img
                              alt=""
                              width="100%"
                              height="100%"
                              src="../../Assets/Others/right-arrow.svg"
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </Tab>

                  <Tab
                    onClick={() => {
                      handleTabIcons(false, true, false);
                    }}
                  >
                    {" "}
                    {loading ? (
                      <SkeletonDisplayText size="large" />
                    ) : (
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "80%" }}>
                          <TextStyle variation="strong">
                            Order Confirmation Template&nbsp;
                          </TextStyle>
                        </div>

                        {!confirmationArrow ? (
                          <div id="order_confirmation_status">
                            {shop.enable_payment_message ? (
                              <Badge status="success">Enabled</Badge>
                            ) : (
                              <Badge status="warning">Disabled</Badge>
                            )}
                          </div>
                        ) : (
                          <div
                            id="order_confirmation_arrow"
                            style={{ paddingLeft: "25%" }}
                          >
                            <img
                              alt=""
                              width="100%"
                              height="100%"
                              src="../../Assets/Others/right-arrow.svg"
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </Tab>
                  <Tab
                    onClick={() => {
                      handleTabIcons(false, false, true);
                    }}
                  >
                    {loading ? (
                      <SkeletonDisplayText size="large" />
                    ) : (
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "80%" }}>
                          <TextStyle variation="strong">
                            Order Delivery Template&nbsp;
                          </TextStyle>
                        </div>
                        {!deliveryArrow ? (
                          <div id="order_delivery_status">
                            {shop.enable_delivery_message ? (
                              <Badge status="success">Enabled</Badge>
                            ) : (
                              <Badge status="warning">Disabled</Badge>
                            )}
                          </div>
                        ) : (
                          <div
                            id="order_delivery_arrow"
                            style={{ paddingLeft: "25%" }}
                          >
                            <img
                              alt=""
                              width="100%"
                              height="100%"
                              src="../../Assets/Others/right-arrow.svg"
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </Tab>
                </TabList>
                <TabPanel>
                  <div className="panel-content">
                    {loading ? (
                      <SettingToggle>
                        <SkeletonBodyText lines={1} />
                        <SkeletonBodyText lines={1} />
                      </SettingToggle>
                    ) : (
                      <SettingToggle
                        action={{
                          content: `${
                            shop.is_automation_enabled === 1
                              ? "Disable automation"
                              : "Enable automation"
                          }`,
                          onAction: () => {
                            let status = shop.is_automation_enabled === 1;
                            activateAutomations(!status, "pre_order");
                          },
                          disabled: activatingAutomation,
                          loading: activatingAutomation,
                        }}
                        enabled={shop.is_automation_enabled === 1}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                          }}
                        >
                          <div>
                            <TextStyle variation="strong">
                              ABANDONED CART RECOVERY AUTOMATION&nbsp;&nbsp;
                            </TextStyle>
                          </div>
                          <div>
                            {shop.is_automation_enabled ? (
                              <Badge status="success">Enabled</Badge>
                            ) : (
                              <Badge status="warning">Disabled</Badge>
                            )}
                          </div>
                        </div>
                      </SettingToggle>
                    )}
                    <Layout.Section secondary>
                      <div>
                        <TextStyle variation="subdued">
                          Send Abandoned Cart Recovery messages on WhatsApp
                          automatically. WhatsApp messages have a very higher
                          open rates, which can skyrocket your
                          conversions.Requests will be approved within 24 hours
                          after WhatsApp verifies your Opt-in settings as given
                          in the guide.&nbsp;
                          <a
                            href="https://help.shopjar.co/whatsapp-automation/automated-abandoned-cart-recovery"
                            target="_blank"
                          >
                            Learn how
                          </a>
                        </TextStyle>

                        <Br height={15} />
                      </div>
                      <LearnHowSection loading={loading} />
                    </Layout.Section>{" "}
                    <Layout.Section>
                      {loading && (
                        <Card sectioned>
                          <TextContainer>
                            <SkeletonDisplayText size="small" />
                            <SkeletonBodyText />
                          </TextContainer>
                          <Br height={30} />
                          <TextContainer>
                            <SkeletonDisplayText size="small" />
                            <SkeletonBodyText />
                          </TextContainer>
                        </Card>
                      )}
                      {!loading && (
                        <>
                          <Br height={20} />
                          <AutomationLists
                            onDeleteAutomation={deleteAutomation}
                            key={uuidv4()}
                            onEditAutomation={(id) => {
                              router.push(`/automations/${id}/edit/pre_order`);
                            }}
                            automations={automations}
                            onAddAutomation={() => {
                              router.push("/automations/0/create/pre_order");
                            }}
                          />
                        </>
                      )}
                    </Layout.Section>
                  </div>
                </TabPanel>{" "}
                <TabPanel>
                  <div className="panel-content">
                    {loading ? (
                      <SettingToggle>
                        <SkeletonBodyText lines={1} />
                        <SkeletonBodyText lines={1} />
                      </SettingToggle>
                    ) : (
                      <SettingToggle
                        action={{
                          content: `${
                            shop.enable_payment_message === 1
                              ? "Disable payment notification"
                              : "Enable payment notification"
                          }`,
                          onAction: () => {
                            let status = shop.enable_payment_message === 1;
                            activateAutomations(!status, "post_order_payment");
                          },
                          disabled: activatingAutomationOrderPayment,
                          loading: activatingAutomationOrderPayment,
                        }}
                        enabled={shop.enable_payment_message === 1}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                          }}
                        >
                          <div>
                            <TextStyle variation="strong">
                              ORDER CONFIRMATION TEMPLATE&nbsp;&nbsp;&nbsp;{" "}
                            </TextStyle>
                          </div>
                          <div>
                            {shop.enable_payment_message ? (
                              <Badge status="success">Enabled</Badge>
                            ) : (
                              <Badge status="warning">Disabled</Badge>
                            )}
                          </div>
                        </div>
                      </SettingToggle>
                    )}

                    <Layout.Section secondary>
                      <>
                        <TextStyle variation="subdued">
                          Automatically send a confirmation message over
                          WhatsApp when a customer places a successful order in
                          your store. Optionally, you can also give a unique
                          coupon code (generated automatically) or a static
                          coupon for their next order.&nbsp;
                          <a
                            href="https://help.shopjar.co/whatsapp-automation/automated-order-confirmation"
                            target="_blank"
                          >
                            Learn how
                          </a>
                        </TextStyle>
                      </>
                      <Br height={30} />
                      <LearnHowSection loading={loading} />
                      <Br height={30} />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <TextStyle variation="strong">
                            Order Confirmation Notification Message
                          </TextStyle>
                        </div>
                        <div style={{ marginRight: "2%" }}>
                          <Button
                            onClick={() => {
                              router.push(
                                `/automations/${orderPaymentNotification.id}/edit/post_order_payment`
                              );
                            }}
                          >
                            <TextStyle variation="subdued">
                              Edit Message
                            </TextStyle>
                          </Button>
                        </div>
                      </div>

                      <div style={{ flex: 1 }}>
                        <Card title="" sectioned>
                          {loading && <SkeletonBodyText lines={3} />}
                          {!loading && (
                            <>
                              <div className="step-image">
                                {orderPaymentNotification && (
                                  <>
                                    <Br height={10} />
                                    <p>{orderPaymentNotification.message}</p>
                                  </>
                                )}
                              </div>
                            </>
                          )}
                        </Card>
                      </div>
                    </Layout.Section>
                    <Br height={100} />
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="panel-content">
                    {loading ? (
                      <SettingToggle>
                        <SkeletonBodyText lines={1} />
                        <SkeletonBodyText lines={1} />
                      </SettingToggle>
                    ) : (
                      <SettingToggle
                        action={{
                          content: `${
                            shop.enable_delivery_message === 1
                              ? "Disable delivery notification"
                              : "Enable delivery notification"
                          }`,
                          onAction: () => {
                            let status = shop.enable_delivery_message === 1;
                            activateAutomations(!status, "post_order_delivery");
                          },
                          disabled: activatingAutomationOrderDelivery,
                          loading: activatingAutomationOrderDelivery,
                        }}
                        enabled={shop.enable_delivery_message === 1}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                          }}
                        >
                          <div>
                            <TextStyle variation="strong">
                              ORDER DELIVERY TEMPLATE&nbsp;&nbsp;&nbsp;{" "}
                            </TextStyle>
                          </div>
                          &nbsp;{" "}
                          <div>
                            {shop.enable_delivery_message ? (
                              <Badge status="success">Enabled</Badge>
                            ) : (
                              <Badge status="warning">Disabled</Badge>
                            )}
                          </div>
                        </div>
                      </SettingToggle>
                    )}

                    <Br height={20} />
                    <Layout.Section secondary>
                      <>
                        <TextStyle variation="subdued">
                          Order delivery message is sent when you fulfill an
                          order in the Shopify Admin. Tracking ID and URL will
                          be taken from your Shopify order data.&nbsp;
                        </TextStyle>
                        <a
                          href="https://help.shopjar.co/whatsapp-automation/automated-delivery-notification"
                          target="_blank"
                        >
                          Learn how
                        </a>
                      </>
                      <Br height={20} />
                      <LearnHowSection loading={loading} />
                      <Br height={30} />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <TextStyle variation="strong">
                            Order Delivery Notification Message
                          </TextStyle>
                        </div>
                        <div style={{ marginRight: "2%" }}>
                          <Button
                            onClick={() => {
                              router.push(
                                `/automations/${orderDeliveryNotification.id}/edit/post_order_delivery`
                              );
                            }}
                          >
                            <TextStyle variation="subdued">
                              Edit Message
                            </TextStyle>
                          </Button>
                        </div>
                      </div>
                      <Br height={20} />
                      <div style={{ flex: 1 }}>
                        <Card title="" sectioned>
                          {loading && <SkeletonBodyText lines={3} />}
                          {!loading && (
                            <div className="step-image">
                              {orderDeliveryNotification && (
                                <>
                                  <Br height={10} />
                                  <p>{orderDeliveryNotification.message}</p>
                                </>
                              )}
                            </div>
                          )}
                        </Card>
                      </div>
                    </Layout.Section>
                    <Br height={100} />
                  </div>
                </TabPanel>{" "}
              </Tabs>
            </Card>
          </Layout.Section>
        </Layout>
      </div>
    </Page>
  );
};

export default Automation;
